import React, { useEffect, useRef, useState } from 'react'
import { TimesheetReportFilterdata } from './TimesheetReportFilter.data';
import { useLazyGetAssignProjectListByUserIdQuery } from '../../../../app/services/projectManagementAPI';
import { setDropdownOptions } from '../../../../components/finalForms/libs/mapDropdownOptions';
import { useLazyGetAllUserQuery } from '../../../../app/services/userAPI';
import CardSection from '../../../../components/ui/card/CardSection';
import Buttons from '../../../../components/ui/button/Buttons';
import FormCreator from '../../../../components/finalForms/FormCreator';

const TimesheetReportFilter = (props) => {

    const timesheetRef = useRef();
    const [timesheetForm, settimesheetForm] = useState(TimesheetReportFilterdata);

    const [getAssignProjectListByUserId, {
        isSuccess: isListSuccess,
        data: ProjectList
    }] = useLazyGetAssignProjectListByUserIdQuery();

    const [getAllUser, {
        isSuccess: isUserListSuccess,
        data: UserList
    },] = useLazyGetAllUserQuery();

    // Fetch assigned projects when the component mounts
    useEffect(() => {
        getAssignProjectListByUserId(props.UserID);
        getAllUser();
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Update project list state when API data is available
    useEffect(() => {
        if (isListSuccess && ProjectList) {
            setDropdownOptions(ProjectList, 'projectId', 'projectName', timesheetForm, 'projectId', settimesheetForm);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isListSuccess, ProjectList]);

    useEffect(() => {
        if (isUserListSuccess && UserList) {
            setDropdownOptions(UserList, 'userId', 'userName', timesheetForm, 'userId', settimesheetForm);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserListSuccess, UserList]);

    const handleClearFilter = () => {
        const form = { ...timesheetForm }
        form.initialState = { ...timesheetForm.initialState }
        settimesheetForm(form);
    }
    const handleGetRecord = () => {
        let timesheetdata = timesheetRef.current.getFormData();
        props.handleGetRecord(timesheetdata);
    }
    const handleDownload = () => {
        let timesheetdata = timesheetRef.current.getFormData();
        props.handleDownload(timesheetdata);
    }

    return (
        <div className='enter-top-space mt-2'>
            <CardSection
                cardTitle="Filter Criteria"
            >
                <FormCreator
                    config={timesheetForm}
                    ref={timesheetRef}
                />
                <div className="po-button d-flex justify-content-end gap-2 col-lg-12 col-md-12">
                    <Buttons
                        buttonTypeClassName="btn-secondary"
                        textWithIcon={true}
                        fontIcon={true}
                        iconName={'ic:round-clear'}
                        buttonText="Clear"
                        onClick={handleClearFilter}
                    />
                    <Buttons
                        buttonTypeClassName="btn theme-btn"
                        textWithIcon={true}
                        fontIcon={true}
                        iconName={'material-symbols:search-rounded'}
                        buttonText="Search"
                        //  isDisable={buttonDisable}
                        onClick={() => handleGetRecord()}
                    />
                    <Buttons
                        buttonTypeClassName="success-btn"
                        textWithIcon={true}
                        fontIcon={true}
                        iconName={'ph:export'}
                        buttonText="Export"
                        onClick={() => handleDownload()}
                    />
                </div>
            </CardSection>
        </div>
    )
}
export default TimesheetReportFilter;
